import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type IExpandedSectionClasses = 'bolded' | 'changeAction' | 'subtitle' | 'colour';

const expandedSectionStyles = makeStyles<ISpcTheme, IExpandedSectionClasses>(
  theme => ({
    bolded: {
      fontWeight: 'bold',
    },
    subtitle: {
      padding: `${theme.spacing(1.2)} 0 0`,
    },
    changeAction: {
      position: 'relative',
      top: '-15px',
    },
    colour: {
      paddingBottom: '10px',
    },
  }),
  { name: 'Customise_ExpandedSection' },
);

export default expandedSectionStyles;
